import keyMirror from 'react-utils/keyMirror';
export const ContentProgressTypes = keyMirror({
  COMPLETED: null,
  FAILED: null,
  IN_REVIEW: null,
  STARTED: null
});
export const PracticalExerciseTypes = keyMirror({
  MANUALLY_GRADED_WITH_FILE_SUBMISSION: null
});
export const videoReferenceType = keyMirror({
  VIDYARD: null,
  HUBSPOT_VIDEO: null
});